module.exports = __webpack_public_path__ + "img/cause3Red.bbdc3da1.png";